/**
 * Premium care statuses.
 *
 * Values follow the SCREAMING_SNAKE convention the Hexa service already uses
 * for its enum (CANCELLED is shared with the previous set).
 */
export const PREMIUM_CARE_STATUS_OPTIONS = [
  { value: 'CONFIRMED', label: 'Confirmed' },
  { value: 'SCHEDULED_FOR_DELIVERY', label: 'Scheduled for Delivery' },
  { value: 'OUT_FOR_DELIVERY', label: 'Out for delivery' },
  { value: 'DELIVERY_SUCCESSFUL', label: 'Delivery Successful' },
  { value: 'DELIVERY_DELAYED', label: 'Delivery Delayed' },
  { value: 'CANCELLED', label: 'Cancelled' },
  { value: 'COMPLAINT_CREATED', label: 'Complaint Created' },
  { value: 'REQUESTED_POSTPONE', label: 'Requested postpone' },
  { value: 'RETURNED', label: 'Returned' },
];

export const PREMIUM_CARE_STATUSES = PREMIUM_CARE_STATUS_OPTIONS.map(
  (option) => option.value
);

/**
 * Labels for display only. Includes the superseded statuses so existing
 * records (many are still PENDING) keep rendering sensibly.
 */
const LEGACY_STATUS_LABELS = {
  PENDING: 'Pending',
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
};

const STATUS_LABELS = PREMIUM_CARE_STATUS_OPTIONS.reduce(
  (acc, option) => ({ ...acc, [option.value]: option.label }),
  { ...LEGACY_STATUS_LABELS }
);

/**
 * Only CANCELLED and RETURNED are red. Note 'primary' is also red in this
 * theme ($primary: $red), so it is deliberately not used here.
 */
export const STATUS_COLORS = {
  CONFIRMED: 'info',
  SCHEDULED_FOR_DELIVERY: 'info',
  OUT_FOR_DELIVERY: 'warning',
  DELIVERY_SUCCESSFUL: 'success',
  DELIVERY_DELAYED: 'warning',
  CANCELLED: 'danger',
  COMPLAINT_CREATED: 'dark',
  REQUESTED_POSTPONE: 'secondary',
  RETURNED: 'danger',
  // superseded, kept so old rows are not all grey
  PENDING: 'warning',
  IN_PROGRESS: 'info',
  COMPLETED: 'success',
};

/** Human label for a status, falling back to the raw value. */
export const statusLabel = (value) => {
  if (!value) return '-';
  return STATUS_LABELS[value] || String(value).replace(/_/g, ' ');
};

export const statusColor = (value) => STATUS_COLORS[value] || 'secondary';

/** Statuses that are final - the record can no longer be edited. */
export const LOCKED_STATUSES = ['DELIVERY_SUCCESSFUL'];

export const isEditable = (status) => !LOCKED_STATUSES.includes(status);
